<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>User Subscription</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field v-model="Search" label="Search" required
           append-outer-icon="mdi-table-search"
           @click:append-outer="onSearch"
           v-on:keyup.enter="onSearch()"
           id="Search"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Subscription
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-select
                v-model="selectedObj.user"
                :rules="userRules"
                :items="users"
                label="User"
                item-text="firstName"
                item-value="id"
                return-object
                required
                id="firstName"
              ></v-select>
            </div>
            <div class="col">
              <v-select
                v-model="selectedObj.publication"
                :rules="publicationRules"
                :items="publications"
                label="Publications"
                item-text="Title"
                item-value="id"
                return-object
                id="publications"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <v-radio-group
                v-model="selectedObj.SubscriptionType"
                row
                v-on:change="onTypeChanges"
                id="subscriptionGroup"
              >
                <v-radio label="Loan" value="Loan" id="loan"></v-radio>
                <v-radio label="Buy" value="Buy" v-if="false" id="buy"></v-radio>
              </v-radio-group>
            </div>
             <div class="col">
               <div v-show="isLoan">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedStartDateFormatted"
                      :rules="startDateRules"
                      label="Start Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>

            <div class="col">
              <div v-show="isLoan">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :rules="endDateRules"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      id="computedDateFormatted"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn class="mr-4" color="primary" @click="onSave()"  :loading="loading" :disabled="loading" id="btnSave">
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
           <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">User</th>
                  <th class="text-left">Publication</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Start Date</th>
                  <th class="text-left">End Date</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.user.firstName }} {{ item.user.lastName }}</td>
                  <td>{{ item.publication.Title }}</td>
                  <td>{{ item.SubscriptionType }}</td>
                  <td>{{ item.startDate | dateUtcToLocal }}</td>
                  <td>{{ item.endDate | dateUtcToLocal }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage"/>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "Subscription",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  created() {
    this.getSubscriptionByPagin();
    this.getUsers();
    this.getPublications();
  },
  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.email.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },

  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getSubscriptionByPagin();
    },
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.SubscriptionType = "Loan";
      this.selectedObj.endDate = "";
      this.selectedObj.status = "";
      this.selectedObj.user = {};
      this.selectedObj.publication = {}; 
      this.date = null;
      this.startDate = null;
    },
    onSave() {
      //this.selectedObj.type = isLoan==true ? 'Loan' : 'Buy';
      this.selectedObj.startDate = this.computedStartDateFormatted;
      this.selectedObj.endDate = this.computedDateFormatted;
      console.log(this.selectedObj);

      //this.$refs.form.validate();
      //if (!this.valid) return;
      if (this.validateFrom()) return;

      this.loading = true; 
      new Promise((resolve, reject) => {
        api
          .update("subscription", this.selectedObj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false; 
              this.isEdit = false;
              this.getSubscriptionByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false; 
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            console.log('error ' + error)
            if (error == 'Error: Request failed with status code 409')
              this.notify.errors.push("Selected user and publication already exist.");
            else
               this.notify.errors.push("Failed to save data. " + error);

            this.loading = false; 
            reject(error);
          });
      });

      
    },
    onEdit(obj) {
      this.isEdit = true;
      this.date =
        obj.endDate == null
          ? null
          : new Date(obj.endDate).toISOString().substr(0, 10);

        this.startDate =  obj.startDate == null
          ? null
          : new Date(obj.startDate).toISOString().substr(0, 10);          
      this.selectedObj = Object.assign({}, obj);
    },
    async onDelete(obj) {
      //this.isEdit = false;
      if (await this.$refs.confirm.open("Confirm","Are you sure, Do you really want to delete this record?")){
        new Promise((resolve, reject) => {
          api
            .DeleteByID("subscription", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getSubscriptionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
    },
    getSubscription() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("subscription")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page){
      this.paging.page = page;
      this.paging.keyword = this.Search      
      this.getSubscriptionByPagin();
    },
    getSubscriptionByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("subscription", this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUsers() {
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user")
          .then((response) => {
            this.users = response.data;
            //this.authors.splice(0, 0, { id: -1, first_name: "" });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPublications() {
      this.publications = [];
      new Promise((resolve, reject) => {
        api
          .getAll("publications")
          .then((response) => {
            this.publications = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
 
    validateFrom() {
      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.type = 4;

      console.log("this.selectedObj.user " + this.selectedObj.user);

      if (this.selectedObj.user.id === undefined) {
        this.notify.errors.push("User is required.");
        return true;
      }
      if (this.selectedObj.publication.id === undefined) {
        this.notify.errors.push("Publication is required.");
        return true;
      }
      console.log(this.selectedObj.endDate);
      if (
        this.selectedObj.endDate == null &&
        this.selectedObj.SubscriptionType == "Loan"
      ) {
        this.notify.errors.push("End date is required.");
        return true;
      }
      if (
        new Date(this.selectedObj.endDate) < new Date() &&
        this.selectedObj.SubscriptionType == "Loan"
      ) {
        this.notify.errors.push(
          "End date should be greater than current current date."
        );
        return true;
      }
       if (
        this.selectedObj.subscriptionType == "Loan" &&
        new Date(this.selectedObj.endDate) > Date(this.selectedObj.startDate)
      ) {
        this.notify.errors.push(
          "End date should be greater than start date."
        );
        return true;
      }

      return false;
    },
    formatDate(date) {
      if (!date) return null;  

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    //dateUtcToLocal(date) {
    //  if (!date) return null;
    //  return moment.utc(String(date)).local().format('MM/DD/YYYY hh:mm')
   // },
    onTypeChanges() {
      this.isLoan = this.selectedObj.SubscriptionType == "Loan" ? true : false;
    },
  },
  data() {
    return {
      valid: true,
      list: [],
      publications: [],
      users: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      isLoan: true,
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      startDate:"",
      date: "", // new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      userRules: [(v) => v || "User is required"],
      publicationRules: [(v) => v || "Publication is required"],
      startDateRules: [(v) => !!v || "Start date is required"],
      endDateRules: [(v) => !!v || "End date is required"],
      loading:false,
      paging: { count: 10, page: 1, size: 10,keyword:'' },
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Subscription.vue